import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import './Master.css';

const AdvocateMaster = () => {
  const { advocates, setAdvocates, addAuditLog } = useApp();
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    advocateName: '',
    barEnrollmentNumber: '',
    barCouncil: '',
    specialization: '',
    email: '',
    contactNumber: '',
    address: '',
    experience: '',
  });
  const [editingId, setEditingId] = useState(null);

  const specializations = [
    'Criminal Law',
    'Civil Law',
    'Family Law',
    'Corporate Law',
    'Constitutional Law',
    'Tax Law',
    'Property Law',
    'Labor Law',
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (editingId) {
      setAdvocates(advocates.map(advocate => 
        advocate.id === editingId 
          ? { ...advocate, ...formData }
          : advocate
      ));
      addAuditLog('Advocate Updated', `Advocate ${formData.advocateName} updated`);
    } else {
      const newAdvocate = {
        id: Date.now().toString(),
        ...formData,
        createdAt: new Date().toISOString(),
      };
      setAdvocates([...advocates, newAdvocate]);
      addAuditLog('Advocate Added', `New advocate ${formData.advocateName} added`);
    }
    
    resetForm();
  };

  const resetForm = () => {
    setFormData({
      advocateName: '',
      barEnrollmentNumber: '',
      barCouncil: '',
      specialization: '',
      email: '',
      contactNumber: '',
      address: '',
      experience: '',
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleEdit = (advocate) => {
    setFormData(advocate);
    setEditingId(advocate.id);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    const advocate = advocates.find(a => a.id === id);
    setAdvocates(advocates.filter(a => a.id !== id));
    addAuditLog('Advocate Deleted', `Advocate ${advocate.advocateName} deleted`);
  };

  return (
    <div className="master-container">
      <div className="master-header">
        <h1>👨‍💼 Advocate Master</h1>
        <button onClick={() => setShowForm(!showForm)} className="btn-primary">
          {showForm ? 'Cancel' : '+ Add Advocate'}
        </button>
      </div>

      {showForm && (
        <div className="master-form-card">
          <h2>{editingId ? 'Edit Advocate' : 'Add New Advocate'}</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group">
                <label>Advocate Name *</label>
                <input
                  type="text"
                  value={formData.advocateName}
                  onChange={(e) => setFormData({...formData, advocateName: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <label>Bar Enrollment Number *</label>
                <input
                  type="text"
                  value={formData.barEnrollmentNumber}
                  onChange={(e) => setFormData({...formData, barEnrollmentNumber: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <label>Bar Council *</label>
                <input
                  type="text"
                  value={formData.barCouncil}
                  onChange={(e) => setFormData({...formData, barCouncil: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <label>Specialization</label>
                <select
                  value={formData.specialization}
                  onChange={(e) => setFormData({...formData, specialization: e.target.value})}
                >
                  <option value="">Select Specialization</option>
                  {specializations.map(spec => (
                    <option key={spec} value={spec}>{spec}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                />
              </div>

              <div className="form-group">
                <label>Contact Number *</label>
                <input
                  type="tel"
                  value={formData.contactNumber}
                  onChange={(e) => setFormData({...formData, contactNumber: e.target.value})}
                  required
                />
              </div>

              <div className="form-group full-width">
                <label>Address</label>
                <textarea
                  value={formData.address}
                  onChange={(e) => setFormData({...formData, address: e.target.value})}
                  rows="3"
                />
              </div>

              <div className="form-group">
                <label>Experience (Years)</label>
                <input
                  type="number"
                  value={formData.experience}
                  onChange={(e) => setFormData({...formData, experience: e.target.value})}
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary">
                {editingId ? 'Update' : 'Add'} Advocate
              </button>
              <button type="button" onClick={resetForm} className="btn-secondary">
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="master-table-card">
        <h2>Advocate List ({advocates.length})</h2>
        {advocates.length > 0 ? (
          <div className="table-container">
            <table className="master-table">
              <thead>
                <tr>
                  <th>Advocate Name</th>
                  <th>Bar Enrollment</th>
                  <th>Bar Council</th>
                  <th>Specialization</th>
                  <th>Contact</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {advocates.map(advocate => (
                  <tr key={advocate.id}>
                    <td><strong>{advocate.advocateName}</strong></td>
                    <td>{advocate.barEnrollmentNumber}</td>
                    <td>{advocate.barCouncil}</td>
                    <td>{advocate.specialization || 'N/A'}</td>
                    <td>{advocate.contactNumber}</td>
                    <td>
                      <button onClick={() => handleEdit(advocate)} className="btn-edit">Edit</button>
                      <button onClick={() => handleDelete(advocate.id)} className="btn-delete">Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="empty-state">No advocates added yet. Click "Add Advocate" to get started.</p>
        )}
      </div>
    </div>
  );
};

export default AdvocateMaster;

